import { assign, find } from 'lodash'

import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './TestObjectsTypes'

function initialState() {
  return {
    items: [],
    editedItem: null,
    loading: false,
  }
}

const mutations = {
  [mutationTypes.SET_TEST_OBJECTS](state, items) {
    state.items = items
  },

  [mutationTypes.SET_EDITED_TEST_OBJECT](state, testObject) {
    state.editedItem = testObject
  },

  [mutationTypes.REPLACE_TEST_OBJECT](state, auditObject) {
    assign(find(state.items, { id: auditObject.id }), auditObject)
  },

  [mutationTypes.SET_LOADING](state, value) {
    state.loading = value
  },

}

const actions = {
  [actionTypes.FETCH_TEST_OBJECTS]({ commit }) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.get('/test-objects').then(({ data: { content } }) => {
      commit(mutationTypes.SET_TEST_OBJECTS, content)
      commit(mutationTypes.SET_LOADING, false)
    })
  },

  [actionTypes.CREATE_TEST_OBJECT]({ commit }, testObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.post('/test-objects', testObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_TEST_OBJECT, null)
    })
  },

  [actionTypes.DELETE_TEST_OBJECT]({ commit, dispatch }, testObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.delete(`/test-objects/${testObject.id}`).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      dispatch(actionTypes.FETCH_TEST_OBJECTS)
    })
  },

  [actionTypes.UPDATE_TEST_OBJECT]({ commit }, testObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.patch(`/test-objects/${testObject.id}`, testObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_TEST_OBJECT, null)
      commit(mutationTypes.REPLACE_TEST_OBJECT, testObject)
    })
  }


}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/TestObjects.js